/*
 * ETA relabel for the add-to-cart button (wording lives in snippets/modus-eta-label.liquid).
 * product-form.liquid puts data-modus-eta-label on each unavailable variant's <option> (and on the
 * default-variant input) when custom.inventorystatus holds an M/D/YYYY date that is not yet past.
 * On a variant switch Empire's ProductDetails._updateButton sets the button to "Sold out"; this
 * runs after it (setTimeout 0) and swaps in the label. The button stays disabled; only its text
 * changes. Empire dispatches variant-change on <variant-selection> without bubbles; a
 * capture-phase listener on document still receives it (same approach as modus-product-specs.js).
 * Never edit empire.js: minify_scripts serves empire.min.js.
 */
(function () {
  document.addEventListener('variant-change', function (e) {
    var d = e.detail || {};
    var variant = d.variant;
    var form = e.target && e.target.closest ? e.target.closest('form') : null;
    if (!variant || variant.available || !form) return;
    setTimeout(function () {
      var source = form.querySelector('select[data-variants] option[value="' + variant.id + '"]') ||
        form.querySelector('input[data-variants][value="' + variant.id + '"]');
      var label = source && source.getAttribute('data-modus-eta-label');
      var button = form.querySelector('[data-product-atc]');
      if (label && button) button.textContent = label;
    }, 0);
  }, true);
})();
